import React, { useState, useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useViewTrades } from "@/features/accounts/shared/hooks/use-view-trades";
import { useInputValidation } from "@/shared/hooks/use-input-validation";

interface Props {
  tradeId: string;
  memo: string;
  passbookType: string;
  onTapCompleteModal: () => void;
  onTapCloseModal: () => void;
}


// 明細メモモーダル
export const MemoModal= ({
  tradeId,
  passbookType,
  memo,
  onTapCompleteModal,
  onTapCloseModal
}: Props) => {
  const { updateDetailMemo } = useViewTrades();
  const [newMemo, setNewMemo] = useState(memo);
  const [isComposing, setIsComposing] = useState(false);

  const { validate } = useInputValidation("deleteOver4Bytes");
  const onChangeMemo = (value: string, composing = isComposing) => {
    // 制限文字をはじく
    value = validate(value, composing);
    setNewMemo(value);
  };


  return (
    <BasePageModal
      title=""
      className="md-memo"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="メモを更新"
          onClick={async () => {
            const success = await updateDetailMemo(
              tradeId,
              newMemo,
              passbookType,
            );
            // API成功時のみモーダルを閉じる
            if (success) {
              onTapCompleteModal();
            }
          }}
        />
      }
      disableOverlayClose={true}
    >
      <textarea
        id="memoText"
        value={newMemo}
        onChange={(e) => {
          onChangeMemo(e.target.value);
        }}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={() => {
          setIsComposing(false);
          // IME確定時は強制的に検証ルールを適用
          onChangeMemo(newMemo, false);
        }}
        maxLength={500}
      />
    </BasePageModal>
  );
};
